import { Link, Text } from '@react-pdf/renderer';
import { Capitalize, ensureHttpProtocol } from 'utils/helpers';

type InfoTitleProps = {
  name?: string;
  status: string;
  website?: string;
};

export const InfoTitle = ({ name, website, status }: InfoTitleProps) => {
  return (
    <Text
      style={{ fontSize: '16px', color: '#151515', fontWeight: 'semibold' }}
    >
      {name && website ? (
        <>
          {name} ({Capitalize(status)}) | {WebsiteComp(website)}
        </>
      ) : website ? (
        <>
          {WebsiteComp(website)} ({Capitalize(status)}){' '}
        </>
      ) : (
        <>Your Information</>
      )}
    </Text>
  );
};

const WebsiteComp = (website: string) => (
  <Link
    style={{
      alignSelf: 'flex-start',
      color: '#151515',
      textDecoration: 'none'
    }}
    src={website ? ensureHttpProtocol(website) : ''}
  >
    {website}
  </Link>
);
